module.exports = __webpack_public_path__ + "wap/img/offlogo.90a907d1.png";